export const IMAGES = {
  hero: "https://customer-assets-agu9un31.emergentagent.net/job_gym-reviews-hub/artifacts/wa1x7v0d_w16aparthotel.webp",
  metro: "https://customer-assets-agu9un31.emergentagent.net/job_gym-reviews-hub/artifacts/ijp26xup_stib.jpg",
  bedroom: "https://customer-assets-agu9un31.emergentagent.net/job_gym-reviews-hub/artifacts/vhtdunw1_Photo%20-%20Superior%20Studio%20%E2%80%93%203rd%20Floor%20-%20002.webp",
  facade: "https://customer-assets-agu9un31.emergentagent.net/job_gym-reviews-hub/artifacts/wa1x7v0d_w16aparthotel.webp",
  fitness: "https://customer-assets-agu9un31.emergentagent.net/job_gym-reviews-hub/artifacts/wdsd00vb_Photo%20-%20Communs%20-%20011.webp",
  entrance: "https://customer-assets-agu9un31.emergentagent.net/job_gym-reviews-hub/artifacts/sjlqo7x7_Photo%20-%20Communs%20-%20004.webp",
  bathroom: "https://customer-assets-agu9un31.emergentagent.net/job_gym-reviews-hub/artifacts/5qr9q3h4_Photo%20-%20Premium%20Studio%201st%20Floor%20with%20Terrace%20-%20025.webp",
  breakfast: "https://customer-assets-agu9un31.emergentagent.net/job_gym-reviews-hub/artifacts/lzpryu3p_Photo%20-%20Premium%20Studio%201st%20Floor%20with%20Terrace%20-%20018.webp",
  garden: "https://customer-assets-agu9un31.emergentagent.net/job_gym-reviews-hub/artifacts/6troum46_Photo%20-%20Exteriors%20-%20017.webp",
  studioBalcony: "https://customer-assets-agu9un31.emergentagent.net/job_gym-reviews-hub/artifacts/d927simm_Photo%20-%20Superior%20Studio%20with%20Balcony%20-%20004.webp",
  studioKitchen: "https://customer-assets-agu9un31.emergentagent.net/job_gym-reviews-hub/artifacts/idqwn9db_Photo%20-%20Superior%20Studio%20with%20Terrace%20-%20007.webp",
  studioRust: "https://customer-assets-agu9un31.emergentagent.net/job_gym-reviews-hub/artifacts/tj26ekl7_Photo%20-%20Premium%20Studio%201st%20Floor%20-%20002.webp",
  studioGold: "https://customer-assets-agu9un31.emergentagent.net/job_gym-reviews-hub/artifacts/ihkpggb7_Photo%20-%20Premium%20Studio%201st%20Floor%20with%20Terrace%20-%20003.webp",
};

export const BOOKING_URL = "https://www.w16aparthotel.be";
export const GOOGLE_REVIEWS_URL =
  "https://www.google.com/maps/search/?api=1&query=W16+Aparthotel+16+Boulevard+Brand+Whitlock+Bruxelles";

export const content = {
  fr: {
    langLabel: "FR",
    nav: { book: "Réserver", chapters: "Le reportage" },
    hero: {
      overline: "16 Boulevard Brand Whitlock · Montgomery, Bruxelles",
      imageAlt:
        "Façade de la maison de maître W16 Aparthotel, 16 Boulevard Brand Whitlock, quartier Montgomery à Bruxelles",
      lines: ["L'adresse", "dont tous", "parlent"],
      intro:
        "Blotti dans le quartier calme et résidentiel de Montgomery, le W16 Aparthotel affiche une moyenne exceptionnelle de 9,2/10. Entre le charme d'une maison de maître bruxelloise et le confort d'un appartement tout équipé, voici pourquoi nos clients repartent conquis — et reviennent.",
      stats: [
        { value: "9,2", label: "note moyenne / 10" },
        { value: "160+", label: "avis clients" },
        { value: "9,4", label: "propreté / 10" },
      ],
      statsShort: ["moyenne", "avis", "propreté"],
      scroll: "Faites défiler",
    },
    marquee: ["Propreté", "Confort", "Calme", "Central", "Autonome", "Lumineux", "9,2/10"],
    chaptersLabel: "Le reportage",
    chapters: [
      {
        num: "01",
        title: "Un emplacement que tout le monde nous envie",
        image: "metro",
        alt: "Panneau du métro Montgomery, à deux pas du W16 Aparthotel à Bruxelles",
        lead:
          "C'est sans doute l'argument qui revient le plus souvent : la situation du W16 est plébiscitée, que l'on voyage pour affaires ou pour le plaisir.",
        body: [
          "À deux pas du métro Montgomery, entouré de restaurants, de cafés et de commerces de proximité, l'aparthotel offre un accès facile au centre-ville tout en préservant une tranquillité rare pour une adresse aussi centrale.",
          "Plusieurs clients soulignent avoir dormi comme des loirs malgré la proximité de la circulation, grâce à une isolation soignée. Une habituée résume l'esprit du lieu : un véritable écrin familial, luxueux et calme au cœur de Bruxelles.",
        ],
      },
      {
        num: "02",
        title: "Des studios pensés dans les moindres détails",
        image: "bedroom",
        alt: "Intérieur d'un studio du W16 : lit et kitchenette",
        lead:
          "Neuf, lumineux, décoré avec goût : voilà les mots qui reviennent sans cesse sous la plume de nos clients.",
        body: [
          "Chaque studio dispose de sa propre kitchenette et d'une literie haut de gamme. Certains profitent même d'une terrasse ou d'un balcon privé.",
          "Une cliente raconte avoir espéré pouvoir prolonger son séjour tant elle s'est sentie bien, entre propreté irréprochable et lit exceptionnellement confortable.",
        ],
      },
      {
        num: "03",
        title: "Une salle de bain spacieuse, une douche généreuse",
        image: "bathroom",
        alt: "Salle de bain design d'un studio du W16 Aparthotel",
        lead:
          "Une salle de bain spacieuse avec douche généreuse — un vrai plus, spécifiquement salué par de nombreux voyageurs.",
        body: [
          "Le confort ne s'arrête pas à la chambre : lignes épurées, matériaux soignés et grands espaces de douche participent à ce sentiment de séjour « comme à la maison », avec une finition digne d'un établissement quatre étoiles.",
        ],
      },
      {
        num: "04",
        title: "Un service au petit soin, malgré l'absence de réception",
        image: "entrance",
        alt: "Entrée et accès en libre-service du W16 Aparthotel, Bruxelles",
        lead:
          "Le W16 mise sur un fonctionnement moderne et autonome, avec accès digital par smartphone.",
        body: [
          "Loin d'être un frein, cette organisation est saluée pour son efficacité : badges, clé digitale envoyée par message, équipe joignable à tout moment — y compris pour un check-in anticipé.",
          "Le manager, Laurent, est même cité nommément par plusieurs voyageurs pour sa gentillesse et sa disponibilité — une attention personnelle rare dans ce type de format.",
        ],
      },
      {
        num: "05",
        title: "Des espaces communs qui font toute la différence",
        image: "fitness",
        alt: "Salle de fitness du W16 Aparthotel à Bruxelles",
        lead:
          "Salle de fitness, jardin arboré, coin lounge avec boissons chaudes et douceurs sucrées : le W16 ne se contente pas de belles chambres.",
        body: [
          "La salle de sport, bien que compacte, est jugée très bien équipée. Et le coin lounge invite à s'attarder autour d'un café.",
        ],
      },
      {
        num: "06",
        title: "Le jardin, un havre de paix",
        image: "garden",
        alt: "Terrasse et jardin privé arboré du W16 Aparthotel",
        lead:
          "Le jardin revient très souvent dans les commentaires comme un véritable havre de paix.",
        body: [
          "On y travaille, on s'y détend, on y prend un café au calme — une respiration verte et privée, rare en pleine ville.",
        ],
      },
      {
        num: "07",
        title: "Une propreté et un confort unanimement salués",
        image: null,
        lead:
          "Difficile de trouver un avis qui ne mentionne pas, à un moment ou un autre, une propreté irréprochable.",
        body: [
          "Ménage quotidien, serviettes renouvelées, literie haut de gamme : nos clients décrivent régulièrement un séjour « comme à la maison », avec un niveau de finition digne d'un quatre étoiles.",
          "Les notes le confirment : 9,4/10 en propreté et 9,3/10 en confort, parmi les plus hautes de la catégorie.",
        ],
      },
    ],
    voicesTitle: "Ce que nos clients en disent, en une phrase",
    reviewsCta: "Lire tous nos avis Google",
    voices: [
      "Le niveau de qualité dépasse largement tout ce que j'ai pu expérimenter jusqu'à présent à Bruxelles.",
      "Un véritable écrin familial, luxueux et calme à Bruxelles.",
      "Emplacement, propreté, confort : tout était parfait.",
    ],
    faqTitle: "Questions fréquentes",
    faq: [
      {
        q: "Où se situe le W16 Aparthotel à Bruxelles ?",
        a: "Le W16 se trouve au 16 Boulevard Brand Whitlock, 1200 Bruxelles, dans le quartier résidentiel et calme de Montgomery — à deux pas de la station de métro Montgomery, entouré de restaurants, cafés et commerces, avec un accès facile au centre-ville.",
      },
      {
        q: "Comment se passe l'arrivée et le check-in ?",
        a: "Le check-in est autonome et 100 % digital : vous recevez votre clé numérique et vos badges par message sur votre smartphone. Il n'y a pas de réception, mais l'équipe reste joignable à tout moment, y compris pour un check-in anticipé.",
      },
      {
        q: "Les studios disposent-ils d'une cuisine ?",
        a: "Oui. Chaque studio possède sa propre kitchenette équipée et une literie haut de gamme. Certains studios profitent en plus d'une terrasse ou d'un balcon privé.",
      },
      {
        q: "Quels équipements et services propose l'établissement ?",
        a: "Le W16 met à disposition une salle de fitness, un jardin privé arboré, un coin lounge avec boissons chaudes et douceurs, le WiFi gratuit et un ménage quotidien avec renouvellement des serviettes.",
      },
      {
        q: "Y a-t-il un ascenseur dans l'immeuble ?",
        a: "Non. L'immeuble est une maison de maître bruxelloise sans ascenseur. Il est possible de demander un étage inférieur au moment de la réservation.",
      },
      {
        q: "Comment obtenir le meilleur tarif ?",
        a: "En réservant en direct sur le site officiel du W16, vous bénéficiez du meilleur tarif disponible et de 10 % de réduction avec le code DBW16.",
      },
      {
        q: "Quelle est la note des clients ?",
        a: "Le W16 Aparthotel affiche une moyenne de 9,2/10 sur plus de 160 avis clients, avec 9,4/10 en propreté et 9,3/10 en confort — parmi les meilleures notes de sa catégorie à Bruxelles.",
      },
    ],
    booking: {
      overline: "Réserver",
      title: "Envie de le vivre à votre tour ?",
      text: "Le charme d'une maison de maître, le confort d'un appartement, la tranquillité d'un quartier résidentiel et un service pensé pour votre autonomie. En réservant en direct sur notre site, profitez du meilleur tarif disponible et de 10 % de réduction avec le code ci-dessous.",
      codeLabel: "Code de réduction −10 %",
      code: "DBW16",
      cta: "Vérifier nos disponibilités",
      note: "L'immeuble, une maison de maître, ne dispose pas d'ascenseur ; le choix d'un étage inférieur est possible à la réservation.",
    },
    footer: {
      address: "16 Boulevard Brand Whitlock, 1200 Bruxelles, Belgique",
      email: "info@w16aparthotel.be",
      phone: "+32 (0)2 681 31 21",
      rights: "W16 Aparthotel · Tous droits réservés",
      disclaimer: "Article promotionnel appuyé sur plus de 160 avis clients réels (moyenne 9,2/10 · propreté 9,4 · confort 9,3).",
    },
  },

  en: {
    langLabel: "EN",
    nav: { book: "Book", chapters: "The report" },
    hero: {
      overline: "16 Boulevard Brand Whitlock · Montgomery, Brussels",
      imageAlt:
        "Facade of the W16 Aparthotel townhouse, 16 Boulevard Brand Whitlock, Montgomery district in Brussels",
      lines: ["The address", "everyone's", "talking about"],
      intro:
        "Tucked away in the quiet, residential Montgomery neighbourhood, W16 Aparthotel boasts an outstanding average of 9.2/10. Blending the charm of a Brussels townhouse with the comfort of a fully equipped apartment, here's why our guests leave delighted — and come back.",
      stats: [
        { value: "9.2", label: "average score / 10" },
        { value: "160+", label: "guest reviews" },
        { value: "9.4", label: "cleanliness / 10" },
      ],
      statsShort: ["average", "reviews", "cleanliness"],
      scroll: "Scroll",
    },
    marquee: ["Cleanliness", "Comfort", "Quiet", "Central", "Self-check-in", "Bright", "9.2/10"],
    chaptersLabel: "The report",
    chapters: [
      {
        num: "01",
        title: "A location everyone envies",
        image: "metro",
        alt: "Montgomery metro sign, steps from W16 Aparthotel in Brussels",
        lead:
          "By far the most frequently praised aspect: guests rave about W16's location, whether travelling for business or leisure.",
        body: [
          "Just steps from Montgomery metro and surrounded by restaurants, cafés and local shops, the aparthotel offers easy access to the city centre while keeping a rare sense of calm for such a central address.",
          "Several guests mention sleeping soundly despite nearby traffic, thanks to careful soundproofing. One returning visitor sums it up: a luxurious, peaceful family retreat in the heart of Brussels.",
        ],
      },
      {
        num: "02",
        title: "Studios designed down to the last detail",
        image: "bedroom",
        alt: "Interior of a W16 studio: bed and kitchenette",
        lead:
          "Brand new, bright, tastefully decorated: the words that show up again and again in our guests' comments.",
        body: [
          "Every studio comes with its own kitchenette and premium bedding. Some even have a private terrace or balcony.",
          "One guest said she wished she could have stayed longer, having felt so at home thanks to spotless cleanliness and an exceptionally comfortable bed.",
        ],
      },
      {
        num: "03",
        title: "A spacious bathroom, a generous shower",
        image: "bathroom",
        alt: "Stylish bathroom in a W16 Aparthotel studio",
        lead:
          "A spacious bathroom with a generous shower — a detail many travellers specifically call out.",
        body: [
          "Comfort doesn't stop at the bedroom: clean lines, quality materials and large shower areas all add to that 'like home' feeling, with a finish worthy of a four-star property.",
        ],
      },
      {
        num: "04",
        title: "Attentive service, even without a front desk",
        image: "entrance",
        alt: "Entrance and self-service access at W16 Aparthotel, Brussels",
        lead:
          "W16 runs on a modern, fully autonomous system with smartphone-based access.",
        body: [
          "Far from a drawback, the setup is praised for its efficiency: badges, digital keys sent by message, and a team reachable at any time — including for last-minute early check-ins.",
          "The manager, Laurent, is repeatedly named by guests for his kindness and availability — a personal touch that's rare in this kind of format.",
        ],
      },
      {
        num: "05",
        title: "Shared spaces that make all the difference",
        image: "fitness",
        alt: "Fitness room at W16 Aparthotel in Brussels",
        lead:
          "A fitness room, a leafy garden, a lounge corner with hot drinks and sweet treats: W16 offers far more than beautiful rooms.",
        body: [
          "The gym, while compact, is described as very well equipped. And the lounge invites you to linger over a coffee.",
        ],
      },
      {
        num: "06",
        title: "The garden, a haven of peace",
        image: "garden",
        alt: "Private landscaped terrace and garden at W16 Aparthotel",
        lead:
          "The garden comes up again and again in reviews as a genuine haven.",
        body: [
          "A place to work, relax, or enjoy a quiet coffee — a green, private breather that's rare in the middle of the city.",
        ],
      },
      {
        num: "07",
        title: "Cleanliness and comfort, universally praised",
        image: null,
        lead:
          "It's hard to find a review that doesn't mention spotless cleanliness at some point.",
        body: [
          "Daily housekeeping, fresh towels, premium bedding: guests consistently describe a stay that feels 'like home,' with a finish worthy of a four-star property.",
          "The scores confirm it: 9.4/10 for cleanliness and 9.3/10 for comfort — among the highest in the category.",
        ],
      },
    ],
    voicesTitle: "What our guests say, in a sentence",
    reviewsCta: "Read all our Google reviews",
    voices: [
      "The level of quality on offer far surpasses anything I had previously experienced in Brussels.",
      "A genuine luxurious, peaceful family retreat in Brussels.",
      "Location, cleanliness, comfort: everything was perfect.",
    ],
    faqTitle: "Frequently asked questions",
    faq: [
      {
        q: "Where is W16 Aparthotel located in Brussels?",
        a: "W16 is at 16 Boulevard Brand Whitlock, 1200 Brussels, in the quiet residential Montgomery neighbourhood — just steps from Montgomery metro station, surrounded by restaurants, cafés and shops, with easy access to the city centre.",
      },
      {
        q: "How does check-in work?",
        a: "Check-in is fully autonomous and digital: you receive your digital key and badges by message on your smartphone. There is no front desk, but the team is reachable at any time, including for early check-ins.",
      },
      {
        q: "Do the studios have a kitchen?",
        a: "Yes. Every studio has its own fully equipped kitchenette and premium bedding. Some studios also feature a private terrace or balcony.",
      },
      {
        q: "What amenities and services are available?",
        a: "W16 offers a fitness room, a private landscaped garden, a lounge corner with hot drinks and sweet treats, free WiFi and daily housekeeping with fresh towels.",
      },
      {
        q: "Is there a lift in the building?",
        a: "No. The building is a Brussels townhouse with no lift. A lower floor can be requested at the time of booking.",
      },
      {
        q: "How do I get the best rate?",
        a: "By booking directly on the official W16 website, you get the best available rate plus 10% off with the code DBW16.",
      },
      {
        q: "What is the guest rating?",
        a: "W16 Aparthotel holds an average of 9.2/10 across 160+ guest reviews, with 9.4/10 for cleanliness and 9.3/10 for comfort — among the highest ratings in its category in Brussels.",
      },
    ],
    booking: {
      overline: "Booking",
      title: "Ready to experience it for yourself?",
      text: "The charm of a historic townhouse, the comfort of an apartment, the calm of a residential neighbourhood, and a service built around your independence. Book directly on our site for the best available rate and 10% off with the code below.",
      codeLabel: "Discount code −10%",
      code: "DBW16",
      cta: "Check availability",
      note: "The building is a townhouse with no lift; a lower floor can be requested at booking.",
    },
    footer: {
      address: "16 Boulevard Brand Whitlock, 1200 Brussels, Belgium",
      email: "info@w16aparthotel.be",
      phone: "+32 (0)2 681 31 21",
      rights: "W16 Aparthotel · All rights reserved",
      disclaimer: "Promotional article based on 160+ genuine guest reviews (average 9.2/10 · cleanliness 9.4 · comfort 9.3).",
    },
  },
};
